export default [
  {
    path: '/etiquetas-producto',
    name: 'product-tags',
    component: () => import('@/views/productTags/ProductTagsList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/nueva-etiqueta-producto',
    name: 'new-product-tag',
    component: () => import('@/views/productTags/ProductTagsNew.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/editar-etiqueta-producto/:productTagId',
    name: 'editProductTag',
    component: () => import('@/views/productTags/ProductTagsEdit.vue'),
    meta: {
      requiresAuth: true,
    },
  },
]
